import FocusManager from './FocusManager.component';

export default FocusManager;
